import { type MarketDto, ProvisionType } from '@containex/portal-backend-dto';

export function marketContainsProvision(market: MarketDto, provision: ProvisionType): boolean {
    return market.provision_types.some((marketProvisionType) => marketProvisionType === provision);
}
